var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.activeComponent,{tag:"component",attrs:{"selectedOrder":_vm.selectedOrder},on:{"backList":_vm.BackList,"OpenOrderDetail":_vm.OpenOrderDetail}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }